exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-investors-finalized-___style__header___p94v4{display:flex;justify-content:space-between}.web-flows-deal-investors-finalized-___style__h2___38IHi{width:100%}.web-flows-deal-investors-finalized-___style__table___p1Z5R{display:flex;flex-flow:column nowrap;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"header": "web-flows-deal-investors-finalized-___style__header___p94v4",
	"h2": "web-flows-deal-investors-finalized-___style__h2___38IHi",
	"table": "web-flows-deal-investors-finalized-___style__table___p1Z5R"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/investors/finalized/style.css
// module id = 1342
// module chunks = 0